import React from 'react';



const ZoomActivatePage = () => {
  

  return <div style={{ textAlign: 'center' }}>
    Zoom Account Deactivated
</div>
  
}


export default ZoomActivatePage
